var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6673_5471",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6673_5471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17C8.2828 17 6.83688 16.4085 5.63335 15.2178C4.42895 14.0263 3.83337 12.6019 3.83337 10.9166C3.83337 10.0648 3.99432 9.28765 4.31078 8.57878C4.63243 7.85829 5.07588 7.21493 5.64368 6.64676L10 2.3675L14.3564 6.64676C14.9242 7.21493 15.3677 7.85829 15.6893 8.57878C16.0058 9.28765 16.1667 10.0648 16.1667 10.9166C16.1667 12.6019 15.5714 14.0263 14.3676 15.2178C13.1635 16.4085 11.7173 17 10 17Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamp);
export default __webpack_public_path__ + "static/media/damp.0abc549740465240210ca677460ba6b5.svg";
export { ForwardRef as ReactComponent };